import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as smartConnectServices from "../../../services/smartConnect/smartConnect.services.js";

export const fetchCreditqAgents = createAsyncThunk(
    "creditqAgents/fetch",
    async (payload, { rejectWithValue }) => {
        try {
            const res = await smartConnectServices.getSmartConnectAgents(payload);

            if (!res?.success) {
                return rejectWithValue(
                    res?.message || "Failed to fetch CreditQ Agents"
                );
            }

            return {
                data: res?.data || [],
                pagination: res?.pagination || {},
            };
        } catch (err) {
            return rejectWithValue(
                err?.response?.data?.message ||
                "Internal Server Issue while fetching CreditQ Agents"
            );
        }
    }
);

const initialState = {
    data: [],
    pagination: {},
    loading: false,
    error: null,
};

const creditqAgentsSlice = createSlice({
    name: "creditqAgents",
    initialState,
    reducers: {
        clearCreditqAgents(state) {
            state.data = [];
            state.pagination = {};
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCreditqAgents.pending, (state) => {
                state.loading = true;
                state.data = [];
                state.error = null;
            })
            .addCase(fetchCreditqAgents.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload.data || [];
                state.pagination = action.payload.pagination || {};
                state.error = null;
            })
            .addCase(fetchCreditqAgents.rejected, (state, action) => {
                state.loading = false;
                state.data = [];
                state.pagination = {};
                state.error = action.payload;
            });
    },
});

export const { clearCreditqAgents } = creditqAgentsSlice.actions;
export const creditqAgentsReducer = creditqAgentsSlice.reducer;
